// extracted by mini-css-extract-plugin
export default {"tab-group_head":"tab-group_head__8FKNz","tab-group_tab":"tab-group_tab__MzI1s","tab-group_active-tab":"tab-group_active-tab__2Ci0t"};